import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, IconButton, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from '../../../../axios-order';
import { useLocation, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IosShareIcon from '@mui/icons-material/IosShare';
import {
    Dialog,
    DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LoadingButton } from '@mui/lab';
import excelIconImage from '../../../../asserts/images/excelicon.svg'
import { canWrite } from '../../../../utils/privilegeUtils';

const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
});

const TdsPayableDashBoard = () => {
    const history = useHistory()
    const location = useLocation();
    const { items } = location.state || {};
    const [tdsData, setTdsData] = useState([]);
    const [tdsSectionWiseSummary, setTdsSectionWiseSummary] = useState([])
    const [netTotals, setNetTotals] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedSectionItem, setSelectedSectionItem] = useState(null)
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogRows, setDialogRows] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [uploadingSectionMap, setUploadingSectionMap] = useState({});
    const [bulkChallanUploadLoading, setBulkChallanUploadLoading] = useState(false);
    // FIX: initialize as array, not object
    const [expandedRows, setExpandedRows] = useState([]);
    const [selectedLineItems, setSelectedLineItems] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);



    useEffect(() => {
        getTdsPaybleDashBoardData();
    }, []);


    const getTdsPaybleDashBoardData = () => {
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            month_name: items.month_name
        };
        axios
            .post('/payable_table3_4', payLoadData)
            .then((res) => {
                if (res.data?.status) {
                    const data = res?.data?.records?.tds_liablity_dashboard_and_Summary
                    setTdsData(data?.first_summary);
                    setNetTotals({
                        total_net_gross_amount: data?.total_net_gross_amount,
                        total_net_tds: data?.total_net_tds,
                        total_tds_payable_amount_per_cws: data?.total_tds_payable_amount_per_cws,
                        total_difference_in_value: data?.total_difference_in_value
                    });
                    setTdsSectionWiseSummary(data?.sec_wise_summary);
                }
            })
            .catch((err) => console.error(err));
    };


    const handleViewTDSPayableDashboardData = (item) => {
        const section = item.section;
        const company_non_company = item.company_non_company;
        const record = tdsSectionWiseSummary.find(item => item.hasOwnProperty(section));
        const data = record?.[section]?.[company_non_company]?.details || [];

        setDialogTitle(`Section ${section}`);
        setSelectedSectionItem(item);
        setDialogRows(data);
        setExpandedRows([]);

        // Pre-select checkboxes where tds_is_selected === 1
        const preSelected = {};
        data.forEach((row) => {
            const lineItems = row.line_items || [];
            lineItems.forEach((li, idx) => {
                if (li.tds_is_selected === 1) {
                    if (!preSelected[row.id]) preSelected[row.id] = {};
                    preSelected[row.id][idx] = li;
                }
            });
        });
        setSelectedLineItems(preSelected);  // ← replaces the old setSelectedLineItems({})

        setOpenDialog(true);
    };


    const handleViewTDSLiabilityCalcultaion = () => {
        history.push({
            pathname: `/TdsLiabilityCalcutionData`,
            state: { items: items }
        })
    }

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_26Q')
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `TDS Payable Reconciliation Report-${financial_year} ${items.month_name}.xlsx`;

        axios
            .post(`/get_payable_challan_recon_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                month : items.month_name
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {

            })
    }


    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr. No.',
            width: 90,
            valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
        },
        { field: 'section', headerName: 'Section', width: 100 },
        {
            field: 'company_non_company',
            headerName: 'Company/Non-Company',
            flex: 1,
        },
        {
            field: 'gross_amount',
            headerName: 'Gross Amount',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'tds_payables',
            headerName: 'TDS Payables',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'tds_payable_per_cws',
            headerName: 'TDS Payables - CWS',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'difference',
            headerName: 'Difference',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'challan_upload',
            headerName: 'Challan Upload',
            width: 200,
            renderCell: (params) => {
                const section = params.row.section;
                const company_non_company = params.row.company_non_company
                const isUploading = uploadingSectionMap[`${section}-${company_non_company}`];
                if (section === "Net Total") return null;

                if (!canWrite("PAYABLES")) return null;

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        {isUploading ? (
                            <CircularProgress size={20} />
                        ) : (
                            <Button
                                variant="outlined"
                                size="small"
                                component="label"
                                sx={{ textTransform: 'none' }}
                                endIcon={<IosShareIcon fontSize="small" />}
                            >
                                Upload
                                <input
                                    type="file"
                                    accept=".pdf"
                                    hidden
                                    onChange={(e) => handleSingleFileChange(e, section, company_non_company)}
                                />
                            </Button>
                        )}
                    </Box>
                );
            },
            sortable: false,
            filterable: false,
        },
        {
            field: 'tds_working',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => {
                const section = params.row.section;
                if (section === "Net Total") return null;
                return (
                    <IconButton color="primary" size="medium" onClick={() => handleViewTDSPayableDashboardData(params.row)}>
                        <VisibilityIcon fontSize="medium" />
                    </IconButton>
                );
            },
            sortable: false,
            filterable: false,
        },


    ];


    const handleSingleFileChange = (event, section, company_non_company) => {
        if (event.target.files?.[0]) {
            const fileData = event.target.files[0];
            setUploadingSectionMap((prev) => ({ ...prev, [`${section}-${company_non_company}`]: true }));
            const fileName = fileData.name;
            const reader = new FileReader();
            reader.readAsDataURL(fileData);
            reader.onload = function () {
                const fileValue = reader.result;
                const payLoadData = {
                    business_entity_id: localStorage.getItem('business_entity_id'),
                    section: section,
                    company_non_company: company_non_company,
                    file: fileValue,
                    month_name: items.month_name,
                    financial_year: localStorage.getItem('financial_year_26Q'),
                    document_name: fileName,
                    is_bulk_upload: false
                }
                axios.post('/upload_repository_in_recon', payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message, 'success')
                        } else {
                            handleSnackbarOpen(res?.data?.message, 'warning')
                        }
                    }).catch((err) => {

                    }).finally(() => {
                        setUploadingSectionMap((prev) => ({ ...prev, [`${section}-${company_non_company}`]: false }));
                    });
            };
            event.target.value = null;

        }

    };


    const handleFileChange = (event) => {
        if (event.target.files?.[0]) {
            const fileData = event.target.files[0];
            setBulkChallanUploadLoading(true)
            const fileName = fileData.name;
            const reader = new FileReader();
            reader.readAsDataURL(fileData);
            reader.onload = function () {
                const fileValue = reader.result;
                const payLoadData = {
                    business_entity_id: localStorage.getItem('business_entity_id'),
                    section: '',
                    file: fileValue,
                    month_name: items.month_name,
                    financial_year: localStorage.getItem('financial_year_26Q'),
                    document_name: fileName,
                    is_bulk_upload: true
                }
                axios.post('/upload_repository_in_recon', payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message, 'success')
                        } else {
                            handleSnackbarOpen(res?.data?.message, 'warning')
                        }
                    }).catch((err) => {

                    }).finally(() => {
                        setBulkChallanUploadLoading(false)
                    })
            };
            event.target.value = null;


        }

    };

    const handleToggleLineItem = (rowId, idx, lineItem) => {
        setSelectedLineItems((prev) => {
            const current = prev[rowId] || {};
            const alreadySelected = !!current[idx];
            if (alreadySelected) {
                const updated = { ...current };
                delete updated[idx];
                return { ...prev, [rowId]: updated };
            } else {
                return { ...prev, [rowId]: { ...current, [idx]: lineItem } };
            }
        });
    };


const handleSubmitSelectedItems = () => {
    const allLineItems = [];

    dialogRows.forEach((row) => {
        const lineItems = row.line_items || [];
        const rowSelections = selectedLineItems[row.id];

        // Skip rows the user never touched
        if (rowSelections === undefined) return;

        const hasAnySelected = lineItems.some((_, idx) => !!(rowSelections?.[idx]));
        const hadAnyPreviouslySelected = lineItems.some((li) => li.tds_is_selected === 1);

        // Only skip if user touched the row BUT nothing selected now AND nothing was selected before
        if (!hasAnySelected && !hadAnyPreviouslySelected) return;

        // Send ALL line items in the row with their current state
        lineItems.forEach((li, idx) => {
            const isNowChecked = !!(rowSelections?.[idx]);
            allLineItems.push({
                ...li,
                tds_is_selected: isNowChecked ? 1 : 0,
            });
        });
    });

    if (allLineItems.length === 0) {
        handleSnackbarOpen('No changes detected to submit.', 'warning');
        return;
    }

    const payloadData = {
        items: allLineItems,
        business_entity_id: Number(localStorage.getItem('business_entity_id')),
        financial_year_list: [localStorage.getItem('financial_year_26Q')],
        org_gstin: localStorage.getItem('gst') || ''
    };

    console.log('Submitting payload:', payloadData);
    setSubmitLoading(true);

    axios.post('/save_selected_line_items', payloadData)
        .then((res) => {
            if (res?.data?.status) {
                handleSnackbarOpen(res?.data?.message || 'Submitted successfully.', 'success');
                getTdsPaybleDashBoardData();
                setSelectedLineItems({});
                setExpandedRows([]);
                setTimeout(() => {
                    setOpenDialog(false);
                    history.push('/Gst2aTdsReconciliation');
                }, 1500);
            } else {
                handleSnackbarOpen(res?.data?.message || 'Submission failed.', 'warning');
            }
        })
        .catch((err) => {
            console.error(err);
            handleSnackbarOpen('Something went wrong during submission.', 'error');
        })
        .finally(() => {
            setSubmitLoading(false);
        });
};

    const handleResetSelectedItems = () => {
        setSelectedLineItems({});
        setExpandedRows([]);
    };


    // const handleToggleLineItem = (rowId, idx) => {
    //     setSelectedLineItems((prev) => {
    //         const current = prev[rowId] || {};
    //         return { ...prev, [rowId]: { ...current, [idx]: !current[idx] } };
    //     });
    // };

    const getDetailPanelContent = ({ row }) => {
        const lineItems = row.line_items || [];
        if (!lineItems.length) return null;
        return (
            <Box sx={{ px: 4, py: 1.5, backgroundColor: '#e8f5e9', borderBottom: '2px solid #a5d6a7' }}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#2e7d32">
                    Line Items — {row.name} ({row.bill_no})
                </Typography>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                        <tr style={{ backgroundColor: '#a5d6a7' }}>
                            {['#', 'Item Name', 'Item Code', 'HSN/SAC', 'Qty', 'UOM', 'Taxable Value',
                                'Non-Taxable', 'IGST', 'CGST', 'SGST', 'Cess', 'Line Item Value', 'GST Rate%', 'Select'].map((h) => (
                                    <th key={h} style={{
                                        padding: '6px 8px', textAlign: 'left',
                                        border: '1px solid #c8e6c9', whiteSpace: 'nowrap', fontWeight: 600
                                    }}>{h}</th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {lineItems.map((li, idx) => (
                            <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f1f8e9' : '#ffffff' }}>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{idx + 1}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.item_name ?? '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.item_code ?? '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.hsn_sac_code ?? '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.quantity ?? '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.uom ?? '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.taxable_value ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.non_taxable_value != null ? currencyFormatter.format(li.non_taxable_value) : '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.integrated_tax ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.central_tax ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.state_tax ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.cess ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{currencyFormatter.format(li.line_item_value ?? 0)}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8' }}>{li.gst_tax_rate != null ? `${li.gst_tax_rate}%` : '—'}</td>
                                <td style={{ padding: '5px 8px', border: '1px solid #dcedc8', textAlign: 'center' }}>
                                    <input
                                        type="checkbox"
                                        checked={!!(selectedLineItems[row.id]?.[idx])}
                                        onChange={() => handleToggleLineItem(row.id, idx, li)}
                                        style={{ cursor: 'pointer', width: 15, height: 15 }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
        );
    };

    const getDetailPanelHeight = ({ row }) => {
        const count = row.line_items?.length || 0;
        return count * 44 + 80;
    };

    const dialogColumns = [
        {
            field: 'sr_no',
            headerName: 'Sr. No.',
            flex: 0.3,
            valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
        },
        {
            field: 'company_non_company',
            headerName: 'Company Type',
            flex: 1,
            renderCell: () => selectedSectionItem?.company_non_company || '',
        },
        { field: 'name', headerName: 'Name of Party', flex: 1.5 },
        { field: 'pan', headerName: 'PAN No', flex: 1 },
        { field: 'bill_no', headerName: 'Invoice No', flex: 1 },
        {
            field: 'booking_date',
            headerName: 'Booking Date',
            flex: 1.2,
            valueFormatter: ({ value }) =>
                value ? new Date(value).toLocaleDateString() : '',
        },
        {
            field: 'net_gross_amount',
            headerName: 'Gross Amount',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'net_tds',
            headerName: 'TDS Payables',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'tds_payable_amount_per_cws',
            headerName: 'TDS Payable AS Per Cws',
            flex: 1.5,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'difference_in_value',
            headerName: 'Difference',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'associated_remark',
            headerName: 'Association Remarks',
            flex: 1.5,
        },
    ];



    const summaryRow = {
        id: 'summary-row',
        sr_no: '',
        section: 'Net Total',
        company_non_company: '', // Leave empty for summary
        gross_amount: netTotals.total_net_gross_amount || 0,
        tds_payables: netTotals.total_net_tds || 0,
        tds_payable_per_cws: netTotals.total_tds_payable_amount_per_cws || 0,
        difference: netTotals.total_difference_in_value || 0,
    };


    return (
        <Box sx={{ width: '100%', mx: 'auto', mt: 3 }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                px={2}
                mb={4}
            >
                {/* Left - Back Button */}
                <Button
                    variant="contained"
                    size="medium"
                    color="primary"

                    onClick={handleViewTDSLiabilityCalcultaion}
                    sx={{ textTransform: 'none', fontWeight: 500 }}
                >
                    TDS Liabilities
                </Button>

                {/* Center - Heading */}
                <Stack direction="row" alignItems="center" spacing={1}>
                    {/* <AccountBalanceWalletIcon color="primary" /> */}
                    <Typography variant="h6" fontWeight={600}>
                        TDS Payable Dashboard ({localStorage.getItem('financial_year_26Q')} {items.month_name})
                    </Typography>
                </Stack>

                {/* Right - Details Button */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {canWrite("PAYABLES") && (
                    <LoadingButton
                        variant="contained"
                        size="medium"
                        color="primary"
                        component="label"
                        startIcon={<IosShareIcon />}
                        loading={bulkChallanUploadLoading}
                        sx={{ textTransform: 'none', fontWeight: 500 }}
                    >
                        <input
                            type="file"
                            accept=".pdf"
                            hidden
                            onChange={handleFileChange}
                        />
                        Bulk Upload
                    </LoadingButton>
                    )}
                    <Button
                        variant="outlined"
                        endIcon={
                            <img
                                src={excelIconImage}
                                alt="Excel"
                                style={{ width: 20, height: 20 }}
                            />
                        }
                        color="success"
                        sx={{ textTransform: 'none', fontWeight: 600, marginLeft: 3 }}
                        onClick={handleDownloadReport}
                    >
                        Export
                    </Button>

                    <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => history.goBack()}
                        sx={{ textTransform: 'none', fontWeight: 500, marginLeft: 2 }}
                    >
                        Back
                    </Button>

                </div>
            </Stack>

            <DataGridPro
                autoHeight
                rows={[...tdsData, summaryRow]}
                columns={columns}
                getRowId={(row) => row.id || `${row.section}-${row.company_non_company}`}
                getRowClassName={(params) =>
                    params.id === 'summary-row' ? 'summary-row' : ''
                }

                hideFooterSelectedRowCount
                sx={{
                    backgroundColor: '#fff',
                    '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#607d8b',
                        color: '#fff',
                        fontWeight: 'bold',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#fafafa',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .summary-row': {
                        backgroundColor: '#f0f4c3',
                        fontWeight: 'bold',
                        '& .MuiDataGrid-cell': {
                            fontWeight: 600,
                            color: '#000000',
                        },
                    },
                }}
            />

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        overflow: 'hidden',
                    }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#e3f2fd',
                        px: 2,
                        py: 1,
                        borderBottom: '1px solid #90caf9',
                    }}
                >
                    <Typography
                        variant="h6"
                        fontWeight={600}
                        sx={{ flexGrow: 1, textAlign: 'center', color: '#0d47a1' }}
                    >
                        {dialogTitle}
                    </Typography>
                    <IconButton onClick={() => setOpenDialog(false)} size="small">
                        <CloseIcon sx={{ color: 'red' }} />
                    </IconButton>
                </Box>

                <DialogContent sx={{ p: 3 }}>
                    <Box sx={{ height: 500 }}>
                        <DataGridPro
                            rows={dialogRows}
                            columns={dialogColumns}
                            getRowId={(row) => row.id}
                            getDetailPanelContent={getDetailPanelContent}
                            getDetailPanelHeight={getDetailPanelHeight}
                            detailPanelExpandedRowIds={expandedRows}
                            onDetailPanelExpandedRowIdsChange={(ids) => setExpandedRows(ids)}
                            sx={{
                                backgroundColor: '#fff',
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: '#607d8b',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                },
                                '& .MuiDataGrid-row:nth-of-type(odd)': {
                                    backgroundColor: '#fafafa',
                                },
                                '& .MuiDataGrid-row:nth-of-type(even)': {
                                    backgroundColor: '#ffffff',
                                },
                                '& .summary-row': {
                                    backgroundColor: '#f0f4c3',
                                    fontWeight: 'bold',
                                    '& .MuiDataGrid-cell': {
                                        fontWeight: 600,
                                        color: '#000000',
                                    },
                                },
                            }}
                        />
                    </Box>

                    {/* Submit and Reset buttons below the grid */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        {/* <Button
                            variant="outlined"
                            color="secondary"
                            sx={{ textTransform: 'none', fontWeight: 500, minWidth: 100 }}
                            onClick={handleResetSelectedItems}
                        >
                            Reset
                        </Button> */}

                        <LoadingButton
                            variant="contained"
                            color="primary"
                            loading={submitLoading}
                            sx={{ textTransform: 'none', fontWeight: 500, minWidth: 100 }}
                            onClick={handleSubmitSelectedItems}
                        >
                            Submit
                        </LoadingButton>

                        {/* <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', fontWeight: 500, minWidth: 100 }}
                            onClick={handleSubmitSelectedItems}
                        >
                            Submit
                        </Button> */}
                    </Box>
                </DialogContent>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>

        </Box>
    );
};

export default TdsPayableDashBoard;
